import React, { useState } from 'react';
import moment from 'moment';
import { withApollo } from 'react-apollo';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableHeadCell,
} from 'components/common/table';
import CustomDate from 'types/date';
import baseURl from 'types/baseURL';
import Input from 'components/common/input';
import toast from 'components/common/toast';
import Loader from 'components/common/loader';
import { Card, CardHeader, CardBody } from 'components/common/card';
import Button from 'components/common/button';
import MainLayout from 'components/templates/main-layout';

import Content from './elements';
import GET_CLOSED_REPORTS from './requests';

const Reports = ({ client }) => {
  const [dateFilter, setDateFilter] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [closedReports, setClosedReports] = useState([]);

  const handleSubmit = async event => {
    event.preventDefault();

    const { closedFrom, closedTo } = setDateRange();

    setIsLoading(true);
    await getClosedReports(closedFrom, closedTo);
    setIsLoading(false);
  };

  const handleChange = event => {
    const {
      target: { id, value },
    } = event;

    setDateFilter({ ...dateFilter, [id]: value });
  };

  const setDateRange = () => {
    const { year, month } = dateFilter;
    let closedFrom = `${year}-01-01`;
    let closedTo = `${year}-12-31`;

    if (month) {
      closedFrom = month.length === 1 ? `${year}-0${month}-01` : `${year}-${month}-01`;
      closedTo = month.length === 1 ? `${year}-0${month}` : `${year}-${month}`;
    }

    closedFrom = new CustomDate(closedFrom).startOf('month').format();
    closedTo = new CustomDate(closedTo).endOf('month').format();
    
    return { closedFrom, closedTo };
  };

  const getClosedReports = async (closedFrom, closedTo) => {
    const { data, errors } = await client.query({
      query: GET_CLOSED_REPORTS,
      variables: { closedFrom, closedTo },
    });

    if (errors) {
      toast.error('Algo salió mal, intentalo de nuevo');
      return;
    }

    setClosedReports(data.closedReports);
    setDateFilter({});

    if(data.closedReports.length > 0) {
      toast.success('Resultados listos');
    } else {
      toast.info('No se encontrarón resultados');
    }
  };

  const downloadFile = reportId => {
    const url = `${baseURl}/csv/closedReport/${reportId}`;

    window.open(url);
  };

  return (
    <MainLayout>
      <Content>
        <Card className="card">
          <CardHeader title="Filtrar reportes"></CardHeader>
          <CardBody>
            <form onSubmit={handleSubmit}>
              <div>
                <Input
                  input
                  type="text"
                  label="Año"
                  primary
                  required
                  pattern="[0-9]*"
                  maxLength="4"
                  title="Solo números"
                  id="year"
                  onChange={handleChange}
                  value={dateFilter.year || ''}
                />
                <Input
                  input
                  type="text"
                  label="Mes"
                  primary
                  maxLength="2"
                  pattern="[0-9]*"
                  title="Solo números"
                  id="month"
                  onChange={handleChange}
                  value={dateFilter.month || ''}
                />
              </div>
              {isLoading ? (
                <Loader alignSelf="flex-end" marginT="10" />
              ) : (
                <Button sm>Filtrar</Button>
              )}
            </form>
          </CardBody>
        </Card>
        {closedReports.length > 0 && (
          <Card marginT="40">
            <CardBody>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableHeadCell>Fecha</TableHeadCell>
                      <TableHeadCell>Etiqueta</TableHeadCell>
                      <TableHeadCell>Responsable</TableHeadCell>
                      <TableHeadCell># Ubicaciones habilitadas</TableHeadCell>
                      <TableHeadCell></TableHeadCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {closedReports.map(item => {
                      const { report, locationNumber } = item;
                      const { creator, createdAt } = report;

                      return (
                        <TableRow key={report.id}>
                          <TableCell>{moment(createdAt).format('DD MMM YYYY h:mm a')}</TableCell>
                          <TableCell>{report.label}</TableCell>
                          <TableCell>{creator.name}</TableCell>
                          <TableCell>{locationNumber}</TableCell>
                          <TableCell>
                            <Button xs onClick={() => downloadFile(report.id)}>
                              Descargar reporte
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardBody>
          </Card>
        )}
      </Content>
    </MainLayout>
  );
};

export default withApollo(Reports);
